module.exports = __webpack_public_path__ + "img/0012.f5224953.png";